<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-form-row @keyup.enter="load">

                    <b-col>
                        <LgFinderPageLocalArmazenamento id="finderLocalArmazenamentConsultarInventario"
                            v-model="localizacaoFisica" label="Localização Física:" :prefix="prefix + title + ' > '"
                            @input="handleSelectLocalArmazenamento" />

                    </b-col>

                    <b-col>

                        <LgFinderPageStatus v-model="status" id="finderPageStatusConsultarInventario"
                            @input="selectStatus" :prefix="[prefix, title]" label="Status:" />

                    </b-col>


                    <b-col>
                        <lg-form-const-select label="Situação:" @change="load()" v-model="situacao"
                            :options="options" />
                    </b-col>

                    <b-col cols="2" class="d-flex justify-content-end mt-2">

                        <div :id="'todosRelatorios-'">
                            <img @click="abrirModal" :src="pdf" class="img img--clickable" alt="pdf" />
                            <b-tooltip :target="'todosRelatorios-'" title="Imprimir Relatórios" />
                        </div>


                    </b-col>


                    <b-col cols="2" class="text-right mt-2">
                        <b-button id="limparArmazenamento" class="mr-2 my-2" size="sm" style="height: 20px" pill
                            variant="primary" @click="clearForm">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="eraser" /> &nbsp;
                            </div>
                            <b-tooltip target="limparArmazenamento" title="Limpar"></b-tooltip>
                        </b-button>

                        <b-button id="localizarArmazenamento" class="mr-2 my-2" size="sm" style="height: 20px" pill
                            variant="primary" @click="load()">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" /> &nbsp;
                            </div>
                            <b-tooltip target="localizarArmazenamento" title="Localizar"></b-tooltip>
                        </b-button>
                    </b-col>

                </b-form-row>

                <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                    :fields="this.tableFields" show-empty>

                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>


                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>

                    <template v-slot:cell(divergencia)="row">

                        <b-button
                            v-if="(((row.item.fiscalLocal && row.item.fiscalLocal.includes(usuario)))
                                ||

                                (row.item.codResponsavel != null && row.item.codResponsavel == usuario)) && row.item.divergente"
                            :id="row.index + 'divergencia-button'" class="my-2" size="sm" pill variant="danger"
                            @click="mudarDivergencia(row.item)">
                            <b-icon icon="exclamation-octagon" />
                            <b-tooltip :target="row.index + 'divergencia-button'"
                                title="Remover divergências..."></b-tooltip>
                        </b-button>

                        <b-button
                            v-if="
                                (row.item.fiscalLocal && row.item.fiscalLocal.includes(usuario) || (
                                    row.item.codResponsavel != null && row.item.codResponsavel == usuario)) && (!row.item.divergente)"
                            :id="row.index + 'divergencia-button'" class="my-2" size="sm" pill variant="success"
                            @click="mudarDivergencia(row.item)">
                            <b-icon icon="exclamation-octagon" />
                            <b-tooltip :target="row.index + 'divergencia-button'"
                                title="Apontar divergências..."></b-tooltip>
                        </b-button>
                    </template>


                    <template v-slot:cell(action)="row">

                        <b-button v-b-tooltip.hover.top="'Adicionar responsável...'"
                            v-if="row.item.codResponsavel == null" :id="row.index + 'novo-button'" class="my-2"
                            size="sm" pill variant="primary" @click="addResponsavel(row.item)">
                            <b-icon icon="person" />

                        </b-button>
                        <b-button
                            v-if="(localizacaoFisica && localizacaoFisica.id && (localizacaoFisica.codFiscais && localizacaoFisica.codFiscais.includes(usuario)))
                                ||
                                (row.item.codResponsavel != null && row.item.codResponsavel == usuario && row.item.codCoResponsavel == null)"
                            :id="row.index + 'novo-co-button'" class="my-2" size="sm" pill variant="primary"
                            @click="addCoResponsavel(row.item)">
                            <b-icon icon="people" />
                            <b-tooltip :target="row.index + 'novo-co-button'"
                                title="Adicionar co-responsável..."></b-tooltip>
                        </b-button>

                        <b-button v-if="temPrivilegioExcluir()" :id="row.index + 'remover-button'" class="my-2"
                            size="sm" pill variant="primary" @click="removerItem(row.item)">
                            <b-icon icon="trash" />
                            <b-tooltip :target="row.index + 'remover-button'" title="Remover item..."></b-tooltip>
                        </b-button>


                        <div class="d-flex align-items-center">


                            <b-button
                                v-if="row.item.precisaAprovar && row.item.codCoResponsavel == usuario && row.item.codCoResponsavel != null"
                                :id="row.index + 'aceitar-co-button'" class="my-2" size="sm" pill variant="success"
                                @click="aceitarCoResponsavel(row.item)">
                                <b-icon icon="check-circle" />
                                <b-tooltip :target="row.index + 'aceitar-co-button'"
                                    title="Aceitar ser co-responsável..."></b-tooltip>
                            </b-button>


                            <b-button
                                v-if="row.item.precisaAprovar && row.item.codCoResponsavel == usuario && row.item.codCoResponsavel != null"
                                :id="row.index + 'rejeitar-co-button'" class="my-2" size="sm" pill variant="danger"
                                @click="rejeitarCoResponsavel(row.item)">
                                <b-icon icon="x-circle" />
                                <b-tooltip :target="row.index + 'rejeitar-co-button'"
                                    title="Rejeitar ser co-responsável..."></b-tooltip>
                            </b-button>
                        </div>

                    </template>


                </b-table>
                <b-row style="margin-top: 12px" v-if="this.records && this.records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>

        <Lg-finder-page-pessoa-modal v-if="mostrarFinderPessoaConsultarInventarioFiltro" @onSelect="handleResponsavel"
            ref="finderPessoaConsultarInventarioFiltro" :prefix="prefix + title + ' > '"></Lg-finder-page-pessoa-modal>

        <Lg-finder-page-pessoa-modal :precisaExistirUsuario="true" v-if="mostrarFinderCoPessoaConsultarInventarioFiltro"
            @onSelect="handleCoResponsavel" ref="finderCoPessoaConsultarInventarioFiltro"
            :prefix="prefix + title + ' > '"></Lg-finder-page-pessoa-modal>


        <ModalRelatorioInventarios @close="fecharModal" v-if="showModal" :prefix="prefix + title + ' > '" />

    </b-card>
</template>

<script>
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import ResourceService from "@/core/api/ResourceService";
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource";
import ConfirmMixin from "@/core/mixins/confirm"
import LgFinderPageLocalArmazenamento from "@/components/Finders/LgFinderPageLocalArmazenamento.vue";
import LgFinderPageStatus from '@/components/Finders/LgFinderPageStatus.vue'
import LgFinderPagePessoaModal from "@/components/Modal/LgFinderPagePessoaModal.vue";
import { getContext } from "@/core/auth"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import PdfIcon from "@/core/assets/icons/pdf.png";
import ModalRelatorioInventarios from "./ModalRelatorioInventarios.vue";

export default {

    components: {
        LgFinderPageLocalArmazenamento,
        LgFinderPageStatus,
        LgFinderPagePessoaModal,
        LgFormConstSelect,
        ModalRelatorioInventarios
    },

    props: {
        idPai: {
            type: Number,
            default: null,
        },

        apenasAtivos: {
            type: Boolean,
            default: false,
        },
        idFinderLocal: {
            type: String,
            default: "",
        },
        showCamposCustomizados: Boolean,
        departamento: Object,
        onDblClickLocalArmazenamentoList: Function,
        prefix: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: "Inventário e Divergências"
        }


    },

    data() {
        return {
            showModal: false,
            pdf: PdfIcon,
            situacao: null,
            options: [
                { value: null, text: "Todos" },
                { value: 1, text: "Aprovação Pendente" },
                { value: 2, text: "Divergentes" },
            ],
            usuario: getContext().usuario.codUsuarioRH,
            nomeUsuario: getContext().usuario.nome,
            mostrarFinderPessoaConsultarInventarioFiltro: false,
            mostrarFinderCoPessoaConsultarInventarioFiltro: false,
            status: {},
            localizacaoFisica: {},
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            filtro: {},

        };
    },
    mixins: [FormResourceMixin, ListResourceMixin, ConfirmMixin],
    beforeMount() {
        this.$service = new ResourceService(`/api/itembempermanente-inventario-filtro`);
        this.load();


    },
    watch: {
        page() {
            this.load();
        },
    },
    computed: {
        locaisFields() {
            return [
                {
                    key: "descricao",
                    label: "Descrição",
                },
                {
                    key: "tipoLocalArmazenamento.descricao",
                    label: "Tipo Local",
                },
                { key: "codigo", label: "Identificador", tdClass: "py-0 col-2" },
                { key: "action", label: " ", tdClass: "w-1" },
            ];
        },

        tableFields() {
            return [
                {
                    key: "divergencia",
                    label: " "
                },
                {
                    key: "action",
                    label: " ",
                },

                {
                    key: "codigoExemplar",
                    label: "Código do Exemplar",
                    tdClass: (value, index, item) => {

                        return item.divergente ? "text-danger p-1" : item.codResponsavel == null?"text-warning p-1":"p-1"
                    },
                },

                {
                    key: "tombamento",
                    label: "Tombamento",
                    tdClass: (value, index, item) => {

                        return item.divergente ? "text-danger p-1" : item.codResponsavel == null?"text-warning p-1":"p-1"
                    },
                },
                {
                    key: "novaetiqueta",
                    label: "Etiqueta Provisória",
                    tdClass: (value, index, item) => {

                        return item.divergente ? "text-danger p-1" : item.codResponsavel == null?"text-warning p-1":"p-1"
                    },

                },

                {
                    key: "responsavel",
                    label: "Responsável",
                    tdClass: (value, index, item) => {

                        return item.divergente ? "text-danger p-1" : item.codResponsavel == null?"text-warning p-1":"p-1"
                    },

                },
                {
                    key: "coResponsavel",
                    label: "CoResponsável",
                    tdClass: (value, index, item) => {  

                        return item.divergente ? "text-danger p-1" : item.codResponsavel == null?"text-warning p-1":"p-1"
                    },

                },

                {
                    key: "departamentos",
                    label: "UORG",
                    tdClass: (value, index, item) => {

                        return item.divergente ? "text-danger p-1" : item.codResponsavel == null?"text-warning p-1":"p-1"
                    },

                },

                {
                    key: "classificador",
                    label: "Classificador",
                    tdClass: (value, index, item) => {

                        return item.divergente ? "text-danger p-1" : item.codResponsavel == null?"text-warning p-1":"p-1"
                    },

                },
                {
                    key: "descricao",
                    label: "Descrição",
                    tdClass: (value, index, item) => {

                        return item.divergente ? "text-danger p-1" : item.codResponsavel == null?"text-warning p-1":"p-1"
                    },

                },
                {
                    key: "codigodependencia",
                    label: "Código Dependência",
                    tdClass: (value, index, item) => {

                        return item.divergente ? "text-danger p-1" : item.codResponsavel == null?"text-warning p-1":"p-1"
                    },

                },
                {
                    key: "nomedependencia",
                    label: "Nome Dependência",
                    tdClass: (value, index, item) => {

                        return item.divergente ? "text-danger p-1" : item.codResponsavel == null?"text-warning p-1":"p-1"
                    },

                },
                {
                    key: "marca",
                    label: "Marca",
                    tdClass: (value, index, item) => {

                        return item.divergente ? "text-danger p-1" : item.codResponsavel == null?"text-warning p-1":"p-1"
                    },

                },
                {
                    key: "modelo",
                    label: "Modelo",
                    tdClass: (value, index, item) => {

                        return item.divergente ? "text-danger p-1" : item.codResponsavel == null?"text-warning p-1":"p-1"
                    },

                },
                {
                    key: "numerodeserie",
                    label: "Número Série",
                    tdClass: (value, index, item) => {

                        return item.divergente ? "text-danger p-1" : item.codResponsavel == null?"text-warning p-1":"p-1"
                    },

                },

                {
                    key: "estadoconservacao",
                    label: "Estado de Conservação",
                    tdClass: (value, index, item) => {

                        return item.divergente ? "text-danger p-1" : item.codResponsavel == null?"text-warning p-1":"p-1"
                    },

                },

                {
                    key: "tipoetiqueta",
                    label: "Tipo Etiqueta",
                    tdClass: (value, index, item) => {

                        return item.divergente ? "text-danger p-1" : item.codResponsavel == null?"text-warning p-1":"p-1"
                    },

                },
            ];
        },
    },
    methods: {
        async removerItem(item) {

            this.busy = true;
            await this.$service.put(`remover-inventario/${item.ibp}`);
            this.busy = false;
            this.$notify({
                type: "success",
                message: "Item Bem Permanente removido com sucesso",
            });

            this.load();

        },


        temPrivilegioExcluir() {
            return verificaPrivilegio(PrivilegiosEnum.INVENTARIO_DIVERGENCIAS_EXCLUIR_IBP);

        },

        async removeLocal(item) {
            this.locaisParaRelatorio.splice(
                this.locaisParaRelatorio.indexOf(item),
                1
            );
        },

        fecharModal() {
            this.locaisParaRelatorio = [];
            this.showModal = false;
        },
        abrirModal() {
            this.showModal = true;
        },

        async mudarDivergencia(item) {

            this.busy = true;
            await this.$service.put(`mudar-divergencia/${item.ibp}`);
            this.busy = false;
            this.$notify({
                type: "success",
                message: "Situação alterada com sucesso",
            });

            this.load();

        },


        async rejeitarCoResponsavel(item) {

            this.busy = true;
            await this.$service.put(`rejeitar-co-responsavel/${item.ibp}`);
            this.busy = false;
            this.$notify({
                type: "success",
                message: "Co-responsabilidade rejeitada com sucesso",
            });

            this.load();

        },

        async aceitarCoResponsavel(item) {

            this.busy = true;
            await this.$service.put(`aceitar-co-responsavel/${item.ibp}`);
            this.busy = false;
            this.$notify({
                type: "success",
                message: "Co-responsabilidade aceita com sucesso",
            });

            this.load();

        },

        async handleCoResponsavel(pessoa) {
            this.mostrarFinderCoPessoaConsultarInventarioFiltro = false;

            this.busy = true;
            try {
                await this.$service.put(`associar-co-responsavel/${this.itemSelecionado.ibp}/${pessoa.id}`);
                this.busy = false;
                this.$notify({
                    type: "success",
                    message: "Co-responsável associado com sucesso",
                });

                this.load();
            }
            catch (error) {
                this.$notify({
                    type: "danger",
                    message: error.response.data,
                });

            }

        },
        async addCoResponsavel(item) {
            this.itemSelecionado = item;
            this.mostrarFinderCoPessoaConsultarInventarioFiltro = true;
            this.$nextTick(() => {
                this.$refs.finderCoPessoaConsultarInventarioFiltro.show();
            });

        },
        async handleResponsavel(pessoa) {
            this.mostrarFinderPessoaConsultarInventarioFiltro = false;

            this.busy = true;
            await this.$service.put(`${this.itemSelecionado.ibp}/${pessoa.id}`);
            this.busy = false;

            this.$notify({
                type: "success",
                message: "Responsável associado com sucesso",
            });

            this.load();

        },
        async addResponsavel(item) {
            this.itemSelecionado = item;
            this.mostrarFinderPessoaConsultarInventarioFiltro = true;
            this.$nextTick(() => {
                this.$refs.finderPessoaConsultarInventarioFiltro.show();
            });

        },

        selectStatus(item) {
            this.status = item;
            this.load();
        },
        handleSelectLocalArmazenamento(item) {
            this.localizacaoFisica = item;
            this.load();
        },
        async load() {
            this.filtro = {};
            this.busy = true;

            if (this.situacao != null && this.situacao == 1)
                this.filtro.aprovarCoResponsabilidade = 1

            if (this.situacao != null && this.situacao == 2)
                this.filtro.divergente = 1

            if (this.localizacaoFisica && this.localizacaoFisica.id)
                this.filtro.local = this.localizacaoFisica.id;

            if (this.status && this.status.id)
                this.filtro.status = this.status.id;

            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,

            });
        },
        clearForm() {

            this.localizacaoFisica = {};
            this.situacao = null;
            this.load();
        },

    },

};
</script>

<style scoped>
.text-danger {
    color: red;
}

.text-warning {
    color: yellow;
}
</style>